import { Injectable } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { CredentialsService } from './credentials.service';
import { UserRoles } from '../shared/models/user.interface'

@Injectable()
export class AuthenticationGuard implements CanActivate {
  public roles = UserRoles;
  constructor(private router: Router,
    private credentialService: CredentialsService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.credentialService.isAuthenticated()) {

      let getRole = route.routeConfig.path.toUpperCase();
      let roleId = UserRoles;
      console.log(this.roles);
      const currentUser = localStorage.getItem("currentUser") || sessionStorage.getItem("currentUser") ;
      if(currentUser !== null){
        const currentRole = JSON.parse(currentUser).userRoles;
        let checkRole = currentRole.filter(u => u.roleId == roleId[getRole]);
        let adminRole = currentRole.filter(u=> u.roleId == roleId['ADMIN']);
  
        if (roleId[getRole] == roleId.OFFICER && checkRole.length || adminRole.length) {
          return true;
        } else if (roleId[getRole] == roleId.STAFF && checkRole.length || adminRole.length) {
          return true;
        }
        if (roleId[getRole] == roleId.ADMIN && checkRole.length || adminRole.length) {
          return true;
        } else {
          if (roleId[getRole] == roleId.OFFICER) {
            this.router.navigate(['/login', { isOfficer: UserRoles.OFFICER }], { replaceUrl: true })
          }
          if (roleId[getRole] == roleId.STAFF) {
            this.router.navigate(['/login', { isVillageStaff: UserRoles.STAFF }], { replaceUrl: true });
          }
          if (roleId[getRole] == roleId.ADMIN) {
            this.router.navigate(['/login', { isAdmin: UserRoles.ADMIN }], { replaceUrl: true })
          }
          return false;
        }
      }
    }
    this.router.navigate(['/sign-in'], { replaceUrl: true });
    return false;
  }

}
